
import { Container, Button, Grid, Link, makeStyles,  CssBaseline, FormControl, Input, InputLabel, InputAdornment, IconButton, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import axios from "axios";
import { useContext, useEffect, useState, KeyboardEvent  } from 'react';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { ApplicationUserContext } from '../../config/Context';
import { ILogin, IServiceUserInfo } from '../../datasolvr/ServicesFacade';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { Logo } from '../../components/ui/Logo';
import { DisplayError } from '../../components/utils/ErrorHandler';
import { planeat_user_group_hierarchy } from '../../constants/userGroupHierarchy';
import { ILoginPlaneat } from '../../interface/interface';
import toast from 'react-hot-toast';

const useStyles = makeStyles((theme: any) => ({
    loginContainer:{
        marginLeft: 15,
        marginRight: 15,
    },
    paper: {
        marginTop: 50,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    inputFieldContainer: {
        marginBottom: '10%'
    },
    form: {
        minWidth: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    forgotSignupContainer: {
        marginTop: '6%',
        color: '#999999'
    },
    forgotLogin: {
        fontSize: 12,
        marginBottom: '15%',
        display: 'flex',
    },
    title: {
        marginTop:'2%',
        marginBottom:'5%',
        fontSize: 20,
        fontWeight: 700
    },
    signInButton: {
        color: 'white',
        fontSize: 14,
        paddingTop: 14,
        paddingBottom: 14,
        fontWeight: 700,
        letterSpacing: 2
    },
}));

  
export const Login: React.FC = () => {
    // Styling
    const classes = useStyles();

    // Routing
    let history = useHistory();

    // State
    const applicationUserContext = useContext(ApplicationUserContext);
    const [loginUser, setLoginUser] = useState<ILoginPlaneat>({
        userId: '',
        password: '',
        showPassword: false,
    });

    useEffect(() => {
        let token = localStorage.getItem("token")
        if(applicationUserContext?.applicationServiceUser && token){
            checkIsVerified(applicationUserContext?.applicationServiceUser)
        }
    },[applicationUserContext])


    const login = () => {
        var credentials: ILogin = {
            'userId': loginUser.userId.toLocaleLowerCase(),
            'password': loginUser.password
        };
        planEatApi.postLogin(credentials)
        .then((response) => {
            localStorage.setItem('token', response.data.token);
            checkUnverifiedThenGetUser(response.data.token, credentials.userId);
        }).catch((error) => {
            DisplayError(error)
            localStorage.clear()
        })  
    }

    // Unverified users cannot read their user, so the groups from the token are used
    const checkUnverifiedThenGetUser = (token: string, userId: string) => {
        planEatApi.postToken(token)
        .then((response) => {
            if(response.data.groups?.includes("unverified_users")){
                localStorage.clear()
                toast.error("Please verify your email using the link we sent you before logging in")
            } else {
                getUserApplicationUser(userId)
            }
        })
        .catch((error) => {
            DisplayError(error)
            localStorage.clear()
        })
    }

    const handleEnterDown = (e: KeyboardEvent) => {
        if(e.key=== "Enter"){
            login()
        }
    }

    const getUserApplicationUser = (userId: string) => {
        planEatApi.getServiceUser(userId)
        .then((response) => {
            applicationUserContext?.setApplicationServiceUser(response.data)
            if(response.data.content){
                if(response.data.content.data_raw){
                    localStorage.setItem('groups', response.data.content.data_raw?.groups.toString());
                    checkIsVerified(response.data)
                }
            }
        })
        .catch((response) => {
            console.log(response);
        })
    }

    const checkIsVerified = (applicationServiceUser: IServiceUserInfo) => {
        if(applicationServiceUser.content.data_raw?.options){
            const verificationToken = applicationServiceUser.content.data_raw?.options.emailVerificationToken
            if(verificationToken){
                return history.push(`/verify/${applicationServiceUser.content.id}/${verificationToken}`)
            } else{
                checkIfPartOfEaterGroup(applicationServiceUser)
            }

        }
    }

    const checkIfPartOfEaterGroup = async (applicationServiceUser: IServiceUserInfo) => {
        var isPartOfEaterGroup = false;
        planEatApi.getUsers()
        .then((response) => {
            var planEatUserExist = false;
            response.data.forEach((user) => {
                if(user.content.applicationUserId === applicationServiceUser.content.id){
                    planEatUserExist = true          
                    if(user.content.eaterGroupId){
                        isPartOfEaterGroup = true;
                    }

                }
            })

            if (isPartOfEaterGroup){
                redirect()
            } else {
                history.push('/signUpInfo');
            }

        })
        .catch((e) => {
            console.log(e)
        })
    }

    const redirect = async () => {
        if(applicationUserContext?.applicationServiceUser){
            var hierarchy = 0;
            applicationUserContext.applicationServiceUser.content.data_raw?.groups.forEach((user_group) => {
                planeat_user_group_hierarchy.forEach((role) => {
                    if(role.name=== user_group){
                        if(role.hierarchy > hierarchy){
                            hierarchy = role.hierarchy
                        }
                    }
                })
            })

            switch(hierarchy){
                case 0:
                    checkIsVerified(applicationUserContext?.applicationServiceUser)
                    break;
                case 1:
                    history.push('/booking');
                    break;
                case 2:
                    history.push('/booking');
                    break;
                case 3:
                    history.push('admin/dashboard');
                    break;
                case 4:
                    history.push('admin/dashboard');
                    break;
                case 5:
                    history.push('admin/dashboard');
                    break;
                case 6:
                    history.push('sysadmin');
                    break;
            }
        }  
    };
    
    const handleChange = (prop: keyof ILoginPlaneat) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setLoginUser({ ...loginUser, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setLoginUser({ ...loginUser, showPassword: !loginUser.showPassword });
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <Container component="main" maxWidth="xs">
            <div className={classes.loginContainer}>
                <CssBaseline />
                <div className={classes.paper}>
                    <Logo variant='normal' />   
                    <div className={classes.title}>
                        Lunch Booking
                    </div>
                    <form className={classes.form} noValidate>
                        <div className={classes.inputFieldContainer}>
                            <TextField
                                margin="normal"
                                fullWidth
                                id="userId"
                                label="Username"
                                name="userId"
                                autoComplete="userId"
                                onChange={handleChange('userId')}
                                onKeyUp={(e) => {handleEnterDown(e)}}
                                type="email"
                                autoCorrect="off"
                                autoCapitalize="none"
                                autoFocus 
                                value = {loginUser.userId}
                            />
                            <FormControl
                                margin="normal"
                                fullWidth>
                                <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
                                    <Input
                                        id="standard-adornment-password"
                                        type={loginUser.showPassword ? 'text' : 'password'}
                                        value={loginUser.password}
                                        onChange={handleChange('password')}
                                        autoCapitalize='off'
                                        onKeyUp={(e) => {handleEnterDown(e)}}
                                        endAdornment=
                                        {
                                        <InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            size="small"
                                            >
                                                {loginUser.showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                        }
                                    />
                            </FormControl>
                        </div>
                        <Button
                            fullWidth
                            variant="contained"
                            className={classes.signInButton}
                            onClick={login}
                        >
                            LOGIN
                        </Button>
                        <Grid
                            container
                            direction="column"
                            justifyContent="space-around"
                            alignItems="center"
                            className={classes.forgotSignupContainer}
                        >
                        <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Link onClick = {() => {history.push("forgotLogin")}}  variant="body2" color="inherit" className={classes.forgotLogin}>
                                    Forgot password?
                                </Link>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Link variant="body2" color="inherit" onClick = {() => {history.push("/signUp")}}>
                                        Don't have an account? <b>Sign Up</b>
                                </Link>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </div>
        </Container>
    );
}